import React from 'react'
import styled from 'styled-components'

const EmailInputField = styled.div`
    display: flex;
    width: 412px;
    margin: 0 auto;
    justify-content: center;
    flex-direction: column;
    margin-top: 50px;

    @media screen and (max-width: 767px){
        width: 300px;
    }
`
const Label = styled.p`
    margin: 0;
    text-align: center;
    font-family: Roboto;
    font-size: 14px;
    font-style: normal;
    font-weight: 600;
    line-height: 14.989px; 
    color: #454545;
    text-align: left;
    margin-bottom: 6px;
`
const InputField = styled.input`
    border: 1px solid #FF7624;
    border-radius: 7px;
    outline: none;
    background-color: #fff;
    padding: 13px;
    color: #454545;
    font-family: Roboto;
    font-size: 14px;
    font-style: normal;
    font-weight: 600;
    line-height: 14.989px;

    &::placeholder{
        color: #AFAFAF;
        font-family: Roboto;
        font-size: 12px;
    }
`
const Error = styled.p`
    margin: 0;
    font-family: Roboto;
    font-size: 10px;
    font-style: normal;
    font-weight: 400;
    line-height: 24px;
    color: #FF4141;
`

export default function EmailField(props) {
    return (
        <div>
            <EmailInputField>
                <Label>Email<span style={{ color: "#FF4141" }}>*</span></Label>
                <InputField value={props.value} placeholder='Enter your work email' onChange={(e) => { props.onChange(e) }}></InputField>
                {props.checkEmailEntered && props.checkEmailEntered.length > 0 && <Error>{props.checkEmailEntered}</Error>}
            </EmailInputField>
        </div>
    )
}
